import React, { useEffect, useRef, useState, useReducer } from 'react';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'


/*
Renders a list as title and list elements. Supports filtering, sorting, custom rendering, labeling etc.
 */
let List = ({
	title = 'LIST TITLE',
	items = [ ],
	RenderItem = ({c, ...props}) => (
		<ListGroup.Item
			{...props}/>
	),
	labeler,
	addButtonTitle = 'NEW ITEM',
	onSelect = () => console.log('select'),
	onAdd = () => console.log('add'),
	selected = 1,
	filter,
	orderFuncs,
	className,
}) => {
	const [searchString, setSearchString] = useState();

	// per default use the first sort function
	const [sortOrder, setSortOrder] = useState(orderFuncs ? Object.entries(orderFuncs)[0][1] : null);

	// sorting

	let sortOrderButton;
	if (orderFuncs) {
		const changeSortOrder = key => {
			console.log('onClick');
			setSortOrder(orderFuncs[key]);
		};

		const sortOrderItems = Object.entries(orderFuncs).map(([key, orderFunc]) => (
			<Dropdown.Item
				className = {orderFunc.icon}
				key = {key}
				eventKey = {key}
				onSelect = {changeSortOrder}>
				{orderFunc.label}
			</Dropdown.Item>
		))

		sortOrderButton = (
			<DropdownButton
				title = {sortOrder.label || <i className={`${sortOrder.icon} mr-1`}/>}>
				{sortOrderItems}
			</DropdownButton>
		);
	}


	// filtering

	let filterInput;
	if (filter) {
		const onFilterInput = ev => {
			ev.preventDefault();
			setSearchString(ev.target.value);
		};

		filterInput = (
			<input
				onChange = {onFilterInput}
				placeholder = {'Suchen ...'}
				value = {searchString || ''}/>
		);
	}


	// list entries

	const filtered = searchString ? items.filter(i => filter(i, searchString)) : items;
	const sorted = sortOrder ? [...filtered].sort(sortOrder.func) : filtered;
	const entries = sorted.map(c => (
		<RenderItem
			item = {c}
			key = {c.id}
			action
			onClick = {() => onSelect(c.id)}
			active = {selected && (c.id === selected.id)}>
			{labeler(c)}
		</RenderItem>
	));



	// render

	return (
		<>
			<Row>
				<Col>
					<h3>
						{title}
					</h3>
				</Col>
				{filter &&
				<Col className = 'd-flex justify-content-center'>
					{filterInput}
				</Col>}
				{orderFuncs &&
				<Col className = 'd-flex justify-content-end'>
					{sortOrderButton}
				</Col>}
			</Row>
			<Row>
				<Col>
					<ListGroup className = {`${className} my-2`}>
						{entries}
					</ListGroup>
					<Button
						onClick = {ev => {
							ev.preventDefault();
							onAdd();
						}}>
						{addButtonTitle}
					</Button>
				</Col>
			</Row>
		</>
	);
};

export default List;
